<template>
    <div
        class="msgbox alert"
        v-html="messageToDisplay">
    </div>
</template>

<script>
export default {
    name: 'ErrorPanel',
    props: {
        message: {
            type: String,
            required: false,
            default: ''
        },
        genericErrorMessage: {
            type: Boolean,
            required: false,
            default: false
        }
    },
    data() {
        return { messageToDisplay: '' };
    },
    mounted() {
        if (this.genericErrorMessage === true) {
            this.messageToDisplay = `We're sorry - the system is experiencing technical difficulties.
                            Please try your request again later.`;
        } else {
            this.messageToDisplay = this.message;
        }
    }
};
</script>
